import React from 'react';

import CustomLink from "../components/custom-link";

const ErrorPage = (props) => {
    return <div className='page-not-found'>
        <div>
            <h4>Please click the link below to home page</h4>
            <CustomLink to="/">Home</CustomLink>
        </div>
        <div>
            <h4>Please call us at the below number for more Details</h4>
            <a href="tel:+12894011359" class="footer-contact-link">Call us at +1(289)-401-1359</a>
        </div>
    </div>
}

export default ErrorPage